import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    width: '100%',
    boxSizing: 'border-box',
  },
}));
